import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { AdminHead } from "./AdminLayout";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [inq, setInq] = useState([]);
  const [importMsg, setImportMsg] = useState("");

  const runImport = async () => {
    setImportMsg("Importing…");
    try {
      const { data } = await api.post("/admin/import-content");
      setImportMsg(
        `Imported — photos ${data.photos.imported} new / ${data.photos.skipped} already there · ` +
        `gear ${data.gear.imported}/${data.gear.skipped} · credits ${data.credits.imported}/${data.credits.skipped}`,
      );
      api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
    } catch (e) {
      setImportMsg(errMsg(e));
    }
  };

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/admin/inquiries").then((r) => setInq(r.data || [])).catch(() => {});
  }, []);

  const cells = [
    ["Photos", stats?.photos, "/admin/photos"],
    ["Visible photos", stats?.photosVisible, "/admin/photos"],
    ["Gear items", stats?.gear, "/admin/gear"],
    ["Credits", stats?.credits, "/admin/credits"],
    ["Booking requests", stats?.inquiries, "/admin/dashboard"],
  ];

  return (
    <div data-testid="admin-dashboard">
      <AdminHead title="Dashboard" sub="Balboa Recording Studio — content control" />
      <div
        style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 16 }}
        data-testid="dashboard-stats"
      >
        {cells.map(([label, val, to]) => (
          <Link to={to} key={label} className="stat">
            <p className="label">{label}</p>
            <p className="disp" style={{ fontSize: 40, marginTop: 8 }}>
              {val ?? "—"}
            </p>
          </Link>
        ))}
      </div>

      <div className="card" style={{ marginTop: 40 }} data-testid="import-content-card">
        <p className="label">First-time setup</p>
        <p className="mono" style={{ fontSize: 13, marginTop: 8 }}>
          Loads the photos, gear, credits and page copy that ship with the site. Safe to run twice — it skips
          anything already here.
        </p>
        <button className="btn btn-sm" style={{ marginTop: 14 }} onClick={runImport} data-testid="import-content-btn">
          Import Starting Content
        </button>
        {importMsg && (
          <p className="mono" style={{ fontSize: 13, marginTop: 10 }} data-testid="import-content-result">
            {importMsg}
          </p>
        )}
      </div>

      <h2 className="disp" style={{ fontSize: 24, marginTop: 56 }}>Recent booking requests</h2>      <div className="misreg-rule" style={{ marginTop: 10, marginBottom: 20 }} />
      {inq.length ? (
        inq.slice(0, 10).map((i) => (
          <div className="card" style={{ marginBottom: 12 }} key={i.id} data-testid={`inquiry-${i.id}`}>
            <p className="mono" style={{ fontSize: 13 }}>
              {i.name} · {i.email} ·{" "}
              <strong>{i.room === "bungalow" ? "Bungalow" : i.room === "either" ? "Either room" : "Balboa"}</strong> ·{" "}
              {i.datesTBD ? "dates TBD" : `${i.startDate || "—"} → ${i.endDate || "—"}`} ·{" "}
              <span style={{ color: i.delivered ? "var(--ink)" : "var(--orange)" }}>
                {i.delivered ? "emailed" : `not emailed (${i.status})`}
              </span>
            </p>
            <p style={{ marginTop: 8 }}>{i.project}</p>
            {i.notes && <p className="mono" style={{ fontSize: 13, marginTop: 6 }}>{i.notes}</p>}
          </div>
        ))
      ) : (
        <div className="empty">— no booking requests yet —</div>
      )}
    </div>
  );
}
